import { createRoot } from "react-dom/client"
import App from "./App.tsx"
import { ErrorBoundary } from "./components/ErrorBoundary.tsx"
import { purgeLegacyCookies } from "./services/api.ts"
import "./index.css"

// Το cache μετακινήθηκε σε localStorage. Καθαρίζει τα παλιά `erp_*` cookies
// που αλλιώς θα συνέχιζαν να στέλνονται σε κάθε request για 7 ημέρες.
purgeLegacyCookies()

// Με lazy routes, ένα ανοιχτό tab από πριν το deploy ζητά chunk hashes που
// δεν υπάρχουν πια. Χωρίς αυτό η πλοήγηση απλώς αποτυγχάνει σιωπηλά.
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault()
  console.warn("Αποτυχία φόρτωσης chunk — πιθανή νέα έκδοση. Γίνεται ανανέωση.")
  window.location.reload()
})

const container = document.getElementById("root")
if (!container) {
  throw new Error('Δεν βρέθηκε το στοιχείο #root στο index.html — η εφαρμογή δεν μπορεί να φορτώσει.')
}

createRoot(container).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
)
